import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';

import { PostBlackList } from 'entities/BlackList/interfaces';
import { useFormikContext } from 'formik';
import { get } from 'lodash';
import ModalWrapper from '../../../ModalWrapper';
import styles from '../../../Forms/Input/Input.module.scss';

type Props = {
  isShow: boolean;
  closeModal: () => void;
  acceptHandler: (data: any) => void;
  id?: string | { type: number; licensePlate: string; isSMCTransport?: boolean };
  type: string;
};

export const CommentModal: React.FC<Props> = ({ isShow, acceptHandler, closeModal, type, id }) => {
  const [val, setValues] = useState<string>('');
  const [errText, setErrText] = useState<string>('');
  const formik = useFormikContext();
  const { values } = formik;

  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    setValues(value);
    if (!value.length) {
      setErrText("Поле обов'язкове");
    } else {
      setErrText('');
    }
  };

  const handleAcept = () => {
    if (val.length < 4) return setErrText("Поле обов'язкове");

    const data: PostBlackList = {
      comment: val,
    };

    if (type === 'driver') {
      const phoneNumber = get(values, 'driver.phone.number', '');
      const lastName = get(values, 'driver.lastName', '');
      data.number = phoneNumber;
      data.description = lastName;
      data.role = 0;
    }

    if (type === 'forwarder') {
      const phoneNumber = get(values, 'forwarder.phone.number', '');
      const lastName = get(values, 'forwarder.lastName', '');
      data.number = phoneNumber;
      data.description = lastName;
      data.role = 1;
    }

    // @ts-ignore
    if (type === 'vehicle' && id?.type === 1) {
      const licensePlate = get(values, 'vehicle.licensePlate', '');
      data.number = licensePlate;
      data.description = 'Автомобіль';
      data.role = 2;
    }

    // @ts-ignore
    if (type === 'vehicle' && id?.type === 2) {
      const licensePlate = get(values, 'trailer.licensePlate', '');
      data.number = licensePlate;
      data.description = 'Автомобіль';
      data.role = 2;
    }

    acceptHandler(data);
    setValues('');
    closeModal();
  };

  return (
    <ModalWrapper show={isShow} onHide={closeModal}>
      <div className="d-flex flex-column">
        <Form.Label className="mb-1">
          Вкажіть причину: <span className="text-danger ml-2">*</span>
        </Form.Label>
        <Form.Control
          as="textarea"
          value={val}
          onChange={changeHandler}
          isInvalid={!!errText}
          className={styles.input}
        />
        {errText ? <Form.Control.Feedback type="invalid">{errText}</Form.Control.Feedback> : null}
        <div className="d-flex justify-content-center mt-3">
          <Button className="px-5" onClick={handleAcept} variant="outline-secondary">
            Зберегти
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
};
